import { render, staticRenderFns } from "./document-category.vue?vue&type=template&id=2c1dd162&scoped=true&"
import script from "./document-category.vue?vue&type=script&lang=js&"
export * from "./document-category.vue?vue&type=script&lang=js&"
import style0 from "./document-category.vue?vue&type=style&index=0&id=2c1dd162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1dd162",
  null
  
)

export default component.exports